/** Illustration aus public/img. Fehlt die Datei, wird nichts angezeigt (Bilder sind optional). */
import { useState } from 'react';

const failed = new Set<string>();
const loaded = new Set<string>();

export function Illu({ src, className = 'illu', alt = '' }: { src: string; className?: string; alt?: string }) {
  const [, force] = useState(0);
  if (failed.has(src)) return null;
  const ok = loaded.has(src);
  return (
    <figure className={className + (ok ? ' on' : '')} aria-hidden={alt ? undefined : true}>
      <img src={src} alt={alt} decoding="async" onLoad={() => { loaded.add(src); force((x) => x + 1); }} onError={() => { failed.add(src); force((x) => x + 1); }} />
    </figure>
  );
}
